module.exports = __webpack_public_path__ + "assets/media/day2.5ba20e22.mp3";